export const {
  REACT_APP_API_BASE_URL: API_BASE_URL = 'localhost:5000',
} = { ...process.env, ...window['env'] }
